// features/jobs/hooks/useGetPendingFeedback.ts

import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { IFeedbackJob } from "../types";

export const QUERY_KEY_FOR_PENDING_FEEDBACK = "PendingFeedback";

interface IGetDataProps {
  token?: string;
}

const getPendingFeedback = async (
  props: IGetDataProps,
): Promise<IFeedbackJob[]> => {
  const url = `${END_POINT.BASE_URL}/v1/job/talent/feedback/pending`;

  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };

  const res = await axios.get(url, config);

  return res.data.data || res.data;
};

export const useGetPendingFeedback = () => {
  const { token } = useGetUserInfo();

  return useQuery(
    [QUERY_KEY_FOR_PENDING_FEEDBACK],
    () => getPendingFeedback({ token }),
    {
      enabled: !!token,
      onError: (err: any) => {
        console.error("Error fetching pending feedback:", err);
      },
    },
  );
};
